import styled from 'styled-components'

export const NfImg = styled.img`
  width: 60%;
  margin: 10px;
`
